export default __webpack_public_path__ + "static/media/chalk-line-fuschia.3f3c632f.svg";